import {
    IDynamicLinkedServiceTypeMetadata,
    ILinkedServiceTypeMetadata
} from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { oracleMetadata, oracleV2LinkedServiceControls } from './oracle-metadata';
import { getOracleLinkedServiceControls } from 'app/registries/consts/metadata-consts';
import { GlobalVariables } from 'app/services/globals';
import { driverVersionVersionOptions, driverVersions } from '../consts/tabular-consts';
import { format } from 'app/shared/utils/string.util';
import { ConnectionAuthKind } from 'shell-models-lib';
import { CommonResourceKind, DataSourceOptionKind } from '@powerquery/mashup-editor-client';

export const amazonRdsForOracleMetadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    const metadata: ILinkedServiceTypeMetadata = {
        ...(await oracleMetadata(injector)),
        icon: {
            className: 'svg-i-100x100-aws_redshift'
        },
        type: adfModelTypeMap.amazonRdsForOracle.linkedServiceType,
        displayName: stringResources.AmazonRdsForOracle_DisplayText,
        showWarningMessage: '{ version !== "v2" }',
        warningMessage: format(
            stringResources.Connector_Legacy_IsNotSupportedWarning_alt5,
            stringResources.VersionLabel.toLocaleLowerCase()
        ),
        warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-amazon-rds-for-oracle',
        isDeprecated: GlobalVariables.showLegacy ? undefined : '{ version !== "v2" }',
        supportedInTrident: true,
        supportAutoFillCopilotInput: true,
        isKnownInPipelineContext: true,
        supportCopyJobSource: true,
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: 'AmazonRdsForOracle' as CommonResourceKind
        },
        supportedAuthKindsInTrident: [ConnectionAuthKind.Basic],
        supportOPDG: GlobalVariables.enableOPDG,
        copySinkTypes: [],
        copySourceTypes: [adfModelTypeMap.amazonRdsForOracle.copySourceType],
        SHIRVersion: {
            v2: '5.54.9260.1'
        },
        controls: [
            {
                type: 'radio-switch',
                bind: 'version',
                label: stringResources.VersionLabel,
                isLabelVertical: true,
                required: true,
                options: driverVersionVersionOptions,
                hide: GlobalVariables.showLegacy ? false : '{version === "v2" }',
                defaultValue: driverVersions.v2,
                cases: [
                    {
                        caseValue: driverVersions.v1,
                        children: [
                            {
                                type: 'hint',
                                hintMode: 'warning',
                                description: format(
                                    stringResources.Connector_Legacy_IsNotSupportedWarning_alt6,
                                    stringResources.VersionLabel.toLocaleLowerCase()),
                                link: 'https://learn.microsoft.com/azure/data-factory/connector-amazon-rds-for-oracle'
                            },
                            ...getOracleLinkedServiceControls(stringResources.AmazonRdsForOracle_DisplayText)
                        ]
                    },
                    {
                        caseValue: driverVersions.v2,
                        children: oracleV2LinkedServiceControls

                    }
                ]
            },
            ...(oracleV2LinkedServiceControls.map((control) => ({
                ...control,
                hide: GlobalVariables.showLegacy ? true : '{version !== "v2" }'
            })))
        ],
        supportDataFlowSource: false,
        supportScriptActivity: false, // blocked by backend
        dataflowSource: undefined
    };

    return metadata;
};
